import { BASE_DOMAIN } from "../constants/app";
import { makeDelete, makeGet, makePatch, makePost } from "./main-api";

const API_URL = {
    GET_ADD: () => `${BASE_DOMAIN}/v1/groups`,
    UPDATE_DELETE: (id: string) => `${BASE_DOMAIN}/v1/groups/${id}`
};

export const getDevicesGroups = () => {
    return makeGet(API_URL.GET_ADD());
};
export const addDevicesGroup = (name: string) => {
    return makePost(API_URL.GET_ADD(), { name });
};
export const deleteDevicesGroup = (id: string) => {
    return makeDelete(API_URL.UPDATE_DELETE(id));
};
export const updateDevicesGroup = (id: string, name: string) => {
    return makePatch(API_URL.UPDATE_DELETE(id), { name });
};
